export default "__VITE_ASSET__CwBGyXmC__"